const HowItWorksText = [
  `We match you with education programs that can advance your career—and we show you how to increase the ROI on your skillbuilding. So your investment leads to more earnings, faster.`,
  `Looking for additional education to climb the corporate ladder`,
  `Need help knowing the actual skills and/or certificates that will set you apart from other candidates`,
  `Thinking about going to graduate school`,
  `Exploring a career change`,
  `Interested in making a passion a career`,
  `MEDIAN LIFETIME EARNINGS BY HIGHEST EDUCATIONAL ATTAINMENT, 2009 DOLLARS`,
  `Source: U.S. Bureau of Labor Statistics.`,
  `AcademME uses real time Labor Market Information (LMI) and Natural Language Processing (NLP) to parse data from thousands of job sources, describing specific skills, education, and experience requirements. So you’ll see labor market trends, and the skills needed to advance--and find the jobs aligned with your goals.`,
  `Sign Up for AcademME (It’s free!)`,
  `Tell us your current position (we’ve got you covered from currently a student to the c-suite…)`,
  `See the background needed to land your dream job`,
  `Prioritize the skills you want to develop based on market demand and ROI`,
  `Find the programs to match your needs—and connect with them`,
  `To compare the best options to learn any skill, use AcademME. We’ll help plan your future.`,
  `You need additional skills to advance at your current company`,
  `You want to find a job, but don’t know what your resume needs or where to get it`,
  `You want to stand out from your competition, and ensure you have the “right” skills to land the role`,
  `You don’t know the next steps for your career, and want to explore education options to make a smart decision`,
  `You want new challenges`,
  `You want to pursue a dream`,
  `UNEMPLOYMENT RATES BY EDUCATIONAL ATTAINMENT, 25 YEARS AND OVER, 1992-2016`,
  `It’s time to upskill.`,
  `AcademME helps you meet local market’s needs, so your upskilling matches labor demand.`,
  `You’ve made the wise decision to upskill now, let AcadmME help you do it smartly.`
]

export default HowItWorksText



// WEBPACK FOOTER //
// src/text/how-text.js